module.exports = __webpack_public_path__ + "static/media/noun_user-svg.25b24044.webp";